import { BillingStatus, PlanTier, Tenant } from '@/lib/types'
import { AlertCircle, CheckCircle2, Clock, XCircle } from 'lucide-react'

export function formatBytes(bytes: number): string {
  if (bytes === -1) return 'Unlimited'
  if (bytes === 0) return '0 B'
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`
}

export function formatNumber(num: number): string {
  if (num === -1) return 'Unlimited'
  return num.toLocaleString()
}

export const getPlanLimits = (tenant: Tenant): {
  maxProjects: number
  maxUsers: number
  maxStorageBytes: number
} => {
  const limits = (tenant as any).tenantPlan?.planLimits ?? (tenant as any).license
  return {
    maxProjects: limits?.maxProjects ?? 5,
    maxUsers: limits?.maxUsers ?? 10,
    maxStorageBytes: limits?.maxStorageBytes ?? (limits?.maxStorage ?? 5) * 1_000_000_000,
  }
}

export const getBillingStatusBadge = (status: BillingStatus | undefined) => {
  switch (status) {
    case 'active':
      return { variant: 'default' as const, icon: CheckCircle2, text: 'Active', className: 'bg-green-600 hover:bg-green-700' }
    case 'trial':
      return { variant: 'secondary' as const, icon: Clock, text: 'Trial', className: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400' }
    case 'past_due':
      return { variant: 'destructive' as const, icon: AlertCircle, text: 'Past Due', className: '' }
    case 'cancelled':
      return { variant: 'outline' as const, icon: XCircle, text: 'Cancelled', className: '' }
    default:
      return { variant: 'outline' as const, icon: Clock, text: 'No Plan', className: '' }
  }
}

export const getPlanBadge = (plan: PlanTier | string | undefined) => {
  if (!plan) return { variant: 'outline' as const, className: '' }
  switch (plan) {
    case 'enterprise':
      return { variant: 'default' as const, className: 'bg-purple-600 hover:bg-purple-700' }
    case 'professional':
      return { variant: 'secondary' as const, className: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400' }
    case 'starter':
      return { variant: 'outline' as const, className: '' }
    default:
      return { variant: 'outline' as const, className: '' }
  }
}
